<div class="scanner-container" [class.scanner-v2]="isV2()">
	<div id="reader" width="400px"></div>

	@if (cameras.length > 1 && state === "ready") {
		<div class="camera-selection-container">
			<ion-select
				label="Camera"
				[value]="currentCameraId"
				class="camera-selector"
				labelPlacement="stacked"
				interface="popover"
				(ionChange)="handleCameraChange($event)"
			>
				@for (camera of cameras; track camera.id) {
					<ion-select-option [value]="camera.id">{{ camera.label }}</ion-select-option>
				}
			</ion-select>
		</div>
	}

	@if (state === "ready") {
		<div class="button-container">
			@if (isV2()) {
				<button type="button" class="scanner-v2-cancel" (click)="dismiss(null)">
					{{ "SCANNER_MODAL__CANCEL" | transloco }}
				</button>
			} @else {
				<ion-button shape="round" (click)="dismiss(null)">
					<ion-label>{{ "SCANNER_MODAL__CANCEL" | transloco }}</ion-label>
				</ion-button>
			}
		</div>
	}
</div>
